import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { EnvironmentKeys, EnvSummary } from '@dat/datiq-nx-repo-utils';
import { startCase } from 'lodash';

export function build(
    element: HTMLElement,
    env: Record<EnvironmentKeys, EnvSummary>,
): am5percent.PieSeries {
    let root = am5.Root.new(element);

    root.setThemes([am5themes_Animated.new(root)]);
    root.container.set('layout', root.verticalLayout);

    let chartContainer = root.container.children.push(
        am5.Container.new(root, {
            layout: root.horizontalLayout,
            width: am5.p100,
            height: am5.p50,
        }),
    );

    let chart = chartContainer.children.push(
        am5percent.PieChart.new(root, {
            endAngle: 270,
        }),
    );

    let series = chart.series.push(
        am5percent.PieSeries.new(root, {
            valueField: 'value',
            categoryField: 'category',
            endAngle: 270,
        }),
    );

    series.states.create('hidden', {
        endAngle: -90,
    });

    series.slices.template.set('tooltipText', '[bold]{category}[/]:{value}');

    series.data.setAll(
        Object.entries(env)
            .filter(([key, value]) => value.total > 0)
            .map(([key, value]) => ({
                category: startCase(key),
                value: value.total,
            })),
    );

    series.appear(1000, 100);

    return series;
}

export function update(
    series: am5percent.PieSeries,
    env: Record<EnvironmentKeys, EnvSummary>,
): am5percent.PieSeries {
    series.data.setAll(
        Object.entries(env)
            .filter(([key, value]) => value.total > 0)
            .map(([key, value]) => ({
                category: startCase(key),
                value: value.total,
            })),
    );

    return series;
}
